import base64 from 'base-64';
import EncodedExcelTemplates from './EncodedExcelTemplates';

const findExcelTemplate = (tableName) => base64.decode(EncodedExcelTemplates[tableName]);

export default findExcelTemplate;
